module.exports = __webpack_public_path__ + "img/ar.f7c6c43d.png";